module.exports = __webpack_public_path__ + "static/media/edit.fa5dc935.svg";